import "./station-map-select.css";
import { FaCaretDown } from "react-icons/fa6";

function StationMapSelect({
  id,
  placeholder,
  displayValue,
  isOpen,
  onToggle,
  disabled = false,
  options = [],
  onSelect,
  fieldClass = "inpt-single",
  ariaLabel,
}) {
  const shownValue = displayValue || placeholder;
  const isPlaceholder = !displayValue;

  return (
    <div className={`arr-dep-content ${fieldClass} ${isOpen ? "is-open" : ""}`}>
      <button
        type="button"
        className="quote-field-trigger"
        onClick={onToggle}
        disabled={disabled}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label={ariaLabel || placeholder}
      >
        <div className="information">
          <div className="input-text">
            <input
              id={id}
              type="text"
              value={shownValue}
              readOnly
              tabIndex={-1}
              className={isPlaceholder ? "is-placeholder" : ""}
            />
          </div>
        </div>

        <span className="arrow" aria-hidden="true">
          <FaCaretDown />
        </span>
      </button>

      <div
        className={`options-content ${isOpen ? "is-open" : ""}`}
        role="listbox"
        aria-label={ariaLabel || placeholder}
      >
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            role="option"
            className="option-home"
            onClick={() => onSelect(option)}
          >
            {option.label ?? option.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default StationMapSelect;
